"use client";

import { forwardRef, useEffect, useState } from "react";
import { useTheme } from "next-themes";
import './style.css';

interface NavBtnProps {
  direction: "prev" | "next";
  className?: string;
  hover: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick?: () => void;
}

export const NavBtn = forwardRef<HTMLButtonElement, NavBtnProps>(
  ({ direction, className, hover, onMouseEnter, onMouseLeave , onClick }, ref) => {
    const [mounted, setMounted] = useState(false);
    const { resolvedTheme } = useTheme();
    const isDark = mounted ? resolvedTheme === "dark" : false;
    const isPrev = direction === "prev";

    useEffect(() => {
      setMounted(true);
    }, []);

    return (
      <button
        ref={ref}
        className={`nav-btn ${className}`}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
         onClick={onClick}  
        style={{
          borderRadius: "50%",
          // width: "54px",
          // height: "54px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          border: isDark
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.15)",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",
          backgroundColor: isDark
            ? hover
              ? "rgba(255,255,255,0.18)"
              : "rgba(255,255,255,0.1)"
            : hover
              ? "rgba(240,240,240,1)"
              : "rgba(255,255,255,1)",
          boxShadow: isDark
            ? "none"
            : hover
              ? "0 2px 8px rgba(0,0,0,0.18), 0 1px 3px rgba(0,0,0,0.12)"
              : "0 1px 4px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)",
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          style={{
            transform: hover
              ? `translateX(${isPrev ? "-3px" : "3px"})`
              : "translateX(0)",
            transition: "transform 0.2s ease",
          }}
        >
          <path
            d={isPrev ? "M15 18L9 12L15 6" : "M9 6L15 12L9 18"}
            stroke={isDark ? "white" : "black"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    );
  },
);

NavBtn.displayName = "NavBtn";
